import { MaskedOptions } from 'imask';

export const convertSurveyMaskToIMask = (surveyMask: string): MaskedOptions => {
  // If no mask is provided, return null
  if (!surveyMask) return null;

  // IMask configuration object
  const imaskConfig = {};

  // Check for numeric mask (9 in SurveyJS)
  if (/9/.test(surveyMask)) {
    // If it's a pure numeric mask (all 9's)
    if (/^[9]+$/.test(surveyMask)) {
      // @ts-ignore
      imaskConfig.mask = Number;
      // @ts-ignore
      imaskConfig.min = 0;
      // @ts-ignore
      imaskConfig.max = '9'.repeat(surveyMask.length);
      return imaskConfig;
    }
  }

  // Process pattern mask
  let pattern = surveyMask;

  // Replace SurveyJS special characters with IMask equivalents
  const replacements = {
    '9': '0', // SurveyJS: 9 for digit -> IMask: 0 for digit
    a: 'a', // SurveyJS: a for letter -> IMask: a for letter
    '*': '*', // SurveyJS: * for any character -> IMask: * for any character
    '#': '0', // SurveyJS: # for digit or space -> special handling required
  };

  // Convert special characters
  let imaskPattern = '';
  for (let i = 0; i < pattern.length; i++) {
    const char = pattern[i];
    if (char === '\\') {
      // Handle escape character in SurveyJS
      if (i + 1 < pattern.length) {
        imaskPattern += pattern[i + 1];
        i++; // Skip the next character as it's escaped
      }
      // @ts-ignore
    } else if (replacements[char]) {
      // @ts-ignore
      imaskPattern += replacements[char];
    } else {
      imaskPattern += char;
    }
  }

  // Handle # (digit or space) from SurveyJS
  if (pattern.includes('#')) {
    // @ts-ignore
    imaskConfig.mask = imaskPattern;
    // @ts-ignore
    imaskConfig.definitions = {
      '0': {
        // @ts-ignore
        validate: function (char) {
          return /[\d\s]/.test(char);
        },
      },
    };
  } else {
    // @ts-ignore
    imaskConfig.mask = imaskPattern;
  }

  return imaskConfig;
};
